import ChipToggle from '@ui/ChipToggle/component'

export default function (): void {
  const crossBorderEl = document.querySelector<HTMLElement>('.cross-border-toggle .o-chip-toggle')
  crossBorderEl && ChipToggle(crossBorderEl)
}
